import { render } from "./LoginPage.vue?vue&type=template&id=591a3461&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=591a3461&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591a3461"]])

export default __exports__